import { render, staticRenderFns } from "./SectionItemsQueryFilter.vue?vue&type=template&id=13dee755"
import script from "./SectionItemsQueryFilter.vue?vue&type=script&lang=js"
export * from "./SectionItemsQueryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports